export default "__VITE_ASSET__C_28FBUr__"